import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { Formik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';

import { getTranslatedString } from 'helpers/i18n';
import TicketCancelForm from './TicketCancelForm';

import { deleteTicket } from 'actions/maintenanceTicketActions';
import { saveTicket } from 'actions/maintenanceTicketActions';

const StyledFormContainer = styled.div`
  padding: 16px;
`;

export const TicketCancelFormBody = ({
  cancelDialog,
  toggleCancelDialog,
  deleteTicket,
  selectedTicket,
  onSubmissionComplete,
  setIsLoading,
  setTicketData,
}) => {
  const handleFormSubmit = values => {
    setIsLoading();
    deleteTicket(selectedTicket.id, values.cancellation_reason).then(response => {
      setTicketData(response.value.maintenance_ticket);
      onSubmissionComplete();
    });
  };

  const validateForm = async values => {
    const requiredErrorVerbiage = getTranslatedString('required');
    let validationSchema = {
      cancellation_reason: Yup.string().required(requiredErrorVerbiage),
    };
    const schema = Yup.object().shape(validationSchema);
    return schema.validate(values, { abortEarly: false }).catch(error => {
      throw yupToFormErrors(error);
    });
  };

  const formName = 'cancel_ticket';

  return (
    <StyledFormContainer>
      <Formik
        initialValues={{ cancellation_reason: undefined }}
        onSubmit={values => handleFormSubmit(values)}
        validate={validateForm}
      >
        {({ handleSubmit, ...rest }) => (
          <form id={formName} onSubmit={handleSubmit}>
            <TicketCancelForm
              toggleCancelDialog={toggleCancelDialog}
              cancelDialog={cancelDialog}
              handleSubmit={handleSubmit}
              {...rest}
            />
          </form>
        )}
      </Formik>
    </StyledFormContainer>
  );
};

const mapStoreToProps = store => {
  return {};
};

const mapDispatchToProps = {
  deleteTicket,
  setTicketData: saveTicket,
};

export default connect(mapStoreToProps, mapDispatchToProps)(TicketCancelFormBody);
